export default __webpack_public_path__ + "static/cover-d7a4b5ee385b618226db27d5bbbe937b.png";